import { DbService } from '~/db'

export default ({ $config, store, redirect }, inject) => {
  const db = new DbService($config.faunaGuestKey, store.state.auth, redirect)
  inject('db', db)
}
